export default __webpack_public_path__ + "static/media/speech-bubble.ebfd5a73.webp";